"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMonitoringService = void 0;
const injection_symbols_1 = require("./injection-symbols");
const enums_1 = require("../../enums");
/**
 * Creates the monitoring service composable instance, for use as a plugin in the Vue app.
 * This service handles sending analytics and monitoring data to our various vendors:
 * - Adobe Analytics
 * - AppDynamics?
 * - Google Analytics
 * - Splunk
 *
 * The API is designed to be generic to work with all of these different platforms.
 */
function createMonitoringService(options) {
    const { commwebService, constituent } = options;
    /**
     * Attempts to interpret the Adobe Target event type syntax automatically in the format
     * that Google Analytics expects. Google Analytics will be going away when we move to AEM.
     * This implementation is not critical.
     */
    function logEventGoogleAnalytics(eventType, eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (window.dataLayer) {
                const [category, action, label, value] = eventType.split('.');
                let eventValue = value;
                let eventLabel = label;
                if (label) {
                    eventValue = JSON.stringify(eventData);
                }
                else {
                    eventLabel = JSON.stringify(eventData);
                }
                window.dataLayer.push({
                    event: 'GAEvent',
                    eventCategory: category,
                    eventAction: action,
                    eventLabel,
                    eventValue
                });
            }
        });
    }
    /**
     * Logs an event to Adobe Target.
     */
    function logEventAdobeTarget(eventType, eventData) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.adobe) === null || _a === void 0 ? void 0 : _a.target) === null || _b === void 0 ? void 0 : _b.trackEvent) {
                window.adobe.target.trackEvent({
                    mbox: 'target-global-mbox',
                    type: eventType,
                    params: eventData
                });
            }
        });
    }
    function logEventSplunk(eventType, eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const formattedData = {};
            for (const key in eventData) {
                formattedData[key.replace(/[A-Z]/g, letter => `_${letter}`).toLowerCase()] = eventData[key];
            }
            yield commwebService.client.post('commservices-eventlog/api/v1/event/' + (constituent !== null && constituent !== void 0 ? constituent : enums_1.Constituent.MEMBER), {
                'comm_web_uuid': yield commwebService.getMonitoringSessionId(),
                'message_type': 'event',
                'event_name': eventType,
                'event_data': JSON.stringify(formattedData)
            });
        });
    }
    /**
     * Logs any generic data for a specified event type, to all of our analytics vendors.
     */
    function logEvent(eventType, eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            /* istanbul ignore next */
            if (!/^[a-zA-Z0-9]{1,}\.[a-zA-Z0-9.]{1,}$/g.test(eventType !== null && eventType !== void 0 ? eventType : '')) {
                console.error('[monitoring-service] logEvent() eventType is rejected.'
                    + 'Please write in the format: featureName.action and write all'
                    + 'variable names in camelCase format.');
            }
            /*
            TODO - Is AppDynamics logging necessary?
            */
            try {
                yield Promise.all([
                    logEventAdobeTarget(eventType, eventData),
                    logEventGoogleAnalytics(eventType, eventData),
                    logEventSplunk(eventType, eventData)
                ]);
            }
            catch (error) { /* Ingore */ }
        });
    }
    // Build the plugin object.
    const monitoringService = {
        logEvent,
        install(app) {
            app.provide(injection_symbols_1.monitoringServiceKey, monitoringService);
        }
    };
    return monitoringService;
}
exports.createMonitoringService = createMonitoringService;
//# sourceMappingURL=monitoring-service.js.map